import OaApiService from './OaApiService';

export default class PropertyService extends OaApiService {
  getAgentProperties(agentKey, data) {
    const queryParams = data
      ? data
      : {
        source: 0,
        startdate: '',
        enddate: '',
        page:0,
      };
    return this.get('/PropertyREST/agent-properties', queryParams, agentKey);
  }

  updatePrice(propertyKey, data) {
    return this.put('/PropertyREST/update-property-price', data, propertyKey);
  }
}
